<template>
  <button
    v-tooltip="{ title: tooltip }"
    :class="'btn btn-' + (className ? className : 'primary')"
    type="button"
    @click="click"
  >
    <FontAwesomeIcon v-if="icon" :icon="'fa-light fa-' + icon" />
    <span v-if="text" :class="icon ? 'ms-2' : ''">{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: "ButtonComponent",
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: false,
      default: "",
    },
    tooltip: {
      type: String,
      required: false,
      default: "",
    },
    className: {
      type: String,
      required: false,
      default: "",
    },
  },
  emits: ["buttonClick"],
  methods: {
    click() {
      this.$emit("buttonClick");
    },
  },
};
</script>

<style lang="scss" scoped></style>
